<template>
  <div v-if="messages && messages.length" class="asset-messages-panel">
    <div class="text-caption font-weight-medium mb-2">{{ title }}</div>
    <v-alert
      v-for="m in messages"
      :key="'amsg-' + m.id"
      :type="m.is_system ? 'warning' : 'info'"
      prominent
      density="compact"
      border="start"
      class="mb-2"
    >
      <div class="d-flex align-start justify-space-between flex-wrap text-caption text-grey-darken-2 mb-1">
        <div>
          <span v-if="m.is_system">{{ systemLabel }}</span>
          <span v-else>{{ userLabel }}</span>
          <span v-if="m.created_at"> · {{ m.created_at }}</span>
        </div>
        <v-btn
          v-if="archiveLabel && !m.archived"
          x-small
          text
          color="primary"
          class="mt-n1"
          @click="$emit('archive', m.id)"
        >
          {{ archiveLabel }}
        </v-btn>
      </div>
      <div class="body-2 markdown-ish" v-html="simpleMarkdown(m.body_markdown)"></div>
    </v-alert>
  </div>
</template>

<script>
export default {
  name: "AssetMessagesPanel",
  props: {
    messages: { type: Array, default: () => [] },
    title: { type: String, required: true },
    systemLabel: { type: String, required: true },
    userLabel: { type: String, required: true },
    /** Empty string hides archive control */
    archiveLabel: { type: String, default: '' },
  },
  methods: {
    /** Minimal formatting: **bold** only; escape HTML in source first. */
    simpleMarkdown(raw) {
      if (raw == null || raw === '') {
        return '';
      }
      const s = String(raw);
      const escaped = s
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/\n/g, '<br>');
      return escaped
        .replace(/\*\*(.+?)\*\*/g, '<strong>$1</strong>')
        .replace(/@([A-Za-z0-9_.+-]+)/g, '<span class="mention">@$1</span>');
    },
  },
};
</script>

<style scoped>
.asset-messages-panel {
  width: 100%;
}
.markdown-ish >>> strong {
  font-weight: 600;
}
.markdown-ish >>> .mention {
  color: #1976d2;
  font-weight: 600;
}
</style>
